import { Component, Input, EventEmitter, Output } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  selector: "myp-segmented-bar",
  templateUrl: "segmented-bar.component.html",
})
export class SegmentedBarComponent extends BaseComponent {
  @Input() options: Array<any>;
  @Input() white: boolean = false;
  @Input() forceWhite: boolean = false;
  @Output() selected: EventEmitter<any> = new EventEmitter();

  constructor(userService: UserService) {
    super(userService);
  }

  selectOption(option) {
    this.options.forEach((item) => (item.selected = item.name != option.name ? false : true));
    this.selected.emit(option);
  }
}
